import { Controller } from '@hotwired/stimulus';
import { useDebounce } from 'stimulus-use';
import $ from 'jquery';

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static targets = [
        'searchInput',
        'cancelButton',
        'submitButton',
        'specialismCheckbox',
        'keywordCheckbox',
        'specialismCollapse',
        'specialismContainer',
        'keywordContainer',
        'errorContainer',
        'removeCount',
        'searchCloseButton',
        'noResultsContainer',
        'errorMessageMin',
        'errorMessageMax',
    ];

    static debounces = ['search'];

    minAllowedSelection = 1;
    maxAllowedSelection = 30;

    connect() {
        useDebounce(this);

        this.createSearchIndex();

        window.resetState = this.resetState.bind(this);

        $(this.element).on('hidden.bs.modal', () => {
            this.resetState();
        });
    }

    openModal() {
        $(this.element).modal({
            backdrop: 'static',
            focus: false,
            show: true,
        });
    }

    closeModal() {
        this.resetState();

        $(this.element).modal('hide');
    }

    resetState() {
        this.searchInputTarget.value = '';

        this.search();

        this.specialismCheckboxTargets.forEach(checkbox => {
            checkbox.checked = 'true' === checkbox.dataset.initialState;
        });

        this.keywordCheckboxTargets.forEach(checkbox => {
            checkbox.checked = 'true' === checkbox.dataset.initialState;
        });

        this.specialismCollapseTargets.forEach(collapse => {
            const shouldBeOpen = 'true' === collapse.dataset.initialState;

            this.changeCollapse(collapse, shouldBeOpen ? 'show' : 'hide');
        });

        this.submitButtonTarget.disabled = false;
        this.cancelButtonTarget.disabled = false;

        this.keywordContainerTargets.forEach(container => {
            $(container).show();
        });
    }

    async submitForm() {
        this.submitButtonTarget.disabled = true;
        this.cancelButtonTarget.disabled = true;

        showPreloader();

        // get selected specialisms and keywords
        const specialismIds = this.specialismCheckboxTargets.filter(checkbox => checkbox.checked).map(checkbox => checkbox.value);
        const keywordIds = this.keywordCheckboxTargets.filter(checkbox => checkbox.checked).map(checkbox => checkbox.value);

        if (specialismIds.length + keywordIds.length > this.maxAllowedSelection) {
            return;
        }

        if (specialismIds.length + keywordIds.length < this.minAllowedSelection) {
            return;
        }

        const url = routes['app_profile_edit'];
        const specialismData = {
            field: 'specialism',
            value: specialismIds.join(','),
        };
        const keywordData = {
            field: 'keywords',
            value: keywordIds.join(','),
        };

        let isSuccess = false;

        const specialismResponse = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
                'X-Requested-With': 'XMLHttpRequest',
            },
            body: new URLSearchParams(specialismData),
        });

        if ((await specialismResponse.json()).status) {
            const keywordsResponse = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
                    'X-Requested-With': 'XMLHttpRequest',
                },
                body: new URLSearchParams(keywordData),
            });

            if ((await keywordsResponse.json()).status) {
                isSuccess = true;
            }
        }

        if (isSuccess) {
            window.location.reload();

            return;
        } else {
            addAlert('danger', translations['profile.An unknown error occurred.']);
        }

        this.submitButtonTarget.disabled = false;
        this.cancelButtonTarget.disabled = false;

        hidePreloader();
    }

    search(event) {
        // search all the specialismsNames, specialismsNamesNormalized, keywordsNames, keywordsNamesNormalized objects for a match and find specialism or keywords ids that match with the input value
        const searchValue = this.searchInputTarget.value.toLowerCase();

        if (searchValue === '') {
            this.searchCloseButtonTarget.style.display = 'none';

            this.specialismContainerTargets.forEach(container => {
                container.style.removeProperty('display');
            });

            if ('undefined' === typeof event) {
                return;
            }

            this.specialismContainerTargets.forEach(container => {
                if ($(container).find('[id^="specialism-collapse-"]').length > 0) {
                    const shouldBeOpen = 'true' === $(container).find('[id^="specialism-collapse-"]')[0].dataset.initialState;

                    this.changeCollapse($(container).find('[id^="specialism-collapse-"]')[0], shouldBeOpen ? 'show' : 'hide');
                }
            });

            return;
        }

        this.searchCloseButtonTarget.style.removeProperty('display');

        if (searchValue.length < 3) {
            return;
        }

        const specialismsToShowFully = [];
        const specialismsToShowWithKeywordsHidden = [];
        const keywordsToShow = [];

        this.specialismsNames.forEach(specialism => {
            if (specialism.value.includes(searchValue)) {
                if (!specialismsToShowFully.includes(specialism.id)) {
                    specialismsToShowFully.push(specialism.id);
                }
            }
        });

        this.specialismsNamesNormalized.forEach(specialism => {
            if (specialism.value.includes(searchValue)) {
                if (!specialismsToShowFully.includes(specialism.id)) {
                    specialismsToShowFully.push(specialism.id);
                }
            }
        });

        this.keywordsNames.forEach(keyword => {
            if (keyword.value.includes(searchValue)) {
                if (specialismsToShowFully.includes(keyword.specialismId)) {
                    return;
                }

                if (!specialismsToShowWithKeywordsHidden.includes(keyword.specialismId)) {
                    specialismsToShowWithKeywordsHidden.push(keyword.specialismId);
                }

                if (!keywordsToShow.includes(keyword.id)) {
                    keywordsToShow.push(keyword.id);
                }
            }
        });

        this.keywordsNamesNormalized.forEach(keyword => {
            if (keyword.value.includes(searchValue)) {
                if (specialismsToShowFully.includes(keyword.specialismId)) {
                    return;
                }

                if (!specialismsToShowWithKeywordsHidden.includes(keyword.specialismId)) {
                    specialismsToShowWithKeywordsHidden.push(keyword.specialismId);
                }

                if (!keywordsToShow.includes(keyword.id)) {
                    keywordsToShow.push(keyword.id);
                }
            }
        });

        this.specialismContainerTargets.forEach(container => {
            const specialismId = container.dataset.specialismId;

            if (specialismsToShowFully.includes(specialismId)) {
                container.style.removeProperty('display');
                this.changeCollapse($(container).find('[id^="specialism-collapse-"]')[0], 'show');
                $(container).find('[data-profile--edit-specialism-modal-target="keywordContainer"]').show();
            } else if (specialismsToShowWithKeywordsHidden.includes(specialismId)) {
                container.style.removeProperty('display');
                this.changeCollapse($(container).find('[id^="specialism-collapse-"]')[0], 'show');
                $(container).find('[data-profile--edit-specialism-modal-target="keywordContainer"]').hide();
            } else {
                container.style.display = 'none';
                this.changeCollapse($(container).find('[id^="specialism-collapse-"]')[0], 'true' === container.dataset.initialState ? 'show' : 'hide');
                $(container).find('[data-profile--edit-specialism-modal-target="keywordContainer"]').show();
            }
        });

        this.keywordContainerTargets.forEach(container => {
            const keywordId = container.dataset.keywordId;

            if (keywordsToShow.includes(keywordId)) {
                $(container).show();
            }
        });

        if (
            0 === specialismsToShowFully.length
            && 0 === specialismsToShowWithKeywordsHidden.length
            && 0 === keywordsToShow.length
        ) {
            $(this.noResultsContainerTarget).show();
        } else {
            $(this.noResultsContainerTarget).hide();
        }
    }

    createSearchIndex() {
        this.specialismsNames = this.specialismCheckboxTargets.map(checkbox => ({
            id: checkbox.value,
            value: checkbox.dataset.name,
        }));
        this.specialismsNamesNormalized = this.specialismCheckboxTargets.map(checkbox => ({
            id: checkbox.value,
            value: checkbox.dataset.normalizedName,
        }));
        this.keywordsNames = this.keywordCheckboxTargets.map(checkbox => ({
            id: checkbox.value,
            value: checkbox.dataset.name,
            specialismId: checkbox.dataset.specialismId,
        }));
        this.keywordsNamesNormalized = this.keywordCheckboxTargets.map(checkbox => ({
            id: checkbox.value,
            value: checkbox.dataset.normalizedName,
            specialismId: checkbox.dataset.specialismId,
        }));
    }

    expandSpecialismIfNeeded(event) {
        const checkbox = event.target;

        if (checkbox.checked) {
            const specialismId = checkbox.dataset.specialismId;
            const $specialismCollapse = $('#specialism-collapse-' + specialismId);

            if ($specialismCollapse.length > 0) {
                this.changeCollapse($specialismCollapse[0], 'show');
            }
        }
    }

    checkForSelectedLimit() {
        this.updateSelectedElementsCount();

        const selectedSpecialismCount = this.specialismCheckboxTargets.filter(checkbox => checkbox.checked).length;
        const selectedKeywordCount = this.keywordCheckboxTargets.filter(checkbox => checkbox.checked).length;
        const selectedCount = selectedSpecialismCount + selectedKeywordCount;
        const allowedMinCount = this.minAllowedSelection;
        const allowedMaxCount = this.maxAllowedSelection;

        if (selectedCount > allowedMaxCount) {
            $(this.errorMessageMinTarget).hide();

            $(this.errorContainerTarget).show();
            $(this.errorMessageMaxTarget).show();

            this.submitButtonTarget.disabled = true;

            this.removeCountTarget.textContent = selectedCount - allowedMaxCount;

        } else if (selectedCount < allowedMinCount) {
            $(this.errorMessageMaxTarget).hide();

            $(this.errorContainerTarget).show();
            $(this.errorMessageMinTarget).show();


            this.submitButtonTarget.disabled = true;

        } else {
            $(this.errorContainerTarget).hide();

            this.submitButtonTarget.disabled = false;
        }
    }

    clearSearch() {
        this.searchInputTarget.value = '';
        this.searchCloseButtonTarget.style.display = 'none';

        this.search();
    }

    changeCollapse(element, state) {
        const $element = $(element);
        const isOpen = $element.hasClass('show');

        if ('show' === state && isOpen) {
            return;
        }

        if ('hide' === state && !isOpen) {
            return;
        }

        $element.collapse(state);
    }

    updateSelectedElementsCount() {
        const count =
            this.specialismCheckboxTargets.filter(checkbox => checkbox.checked).length +
            this.keywordCheckboxTargets.filter(checkbox => checkbox.checked).length;

        this.element.querySelectorAll('.specialism-count strong').forEach(element => {
            element.textContent = String(count);
        });
    }
}
